<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetVideoSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    title: '',
    showTitle: false,
    youtubeId: '',
    image: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :invalid-feedback="form.$errors.first('settings.showTitle')" :state="form.$errors.state('settings.showTitle')" :nospace="true">
        <IdeoFormCheckbox v-model="form.settings.showTitle">
            {{ $t('[[[Wyświetlaj tytuł]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Tytuł okładki]]]')" :invalid-feedback="form.$errors.first('settings.title')" :state="form.$errors.state('settings.title')">
        <IdeoFormInput v-model="form.settings.title" type="text" name="title" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[YouTube (ID)]]]')" :invalid-feedback="form.$errors.first('settings.youtubeId')" :state="form.$errors.state('settings.youtubeId')">
        <IdeoFormInput v-model="form.settings.youtubeId" type="text" name="youtubeId" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Zdjęcie]]]')" :invalid-feedback="form.$errors.first(`settings.image`)" :state="form.$errors.state(`settings.image`)">
        <IdeoFilePicker id="image" v-model="form.settings.image" media="images" />
    </IdeoFormGroup>
</template>
